import script from "./MusicPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&setup=true&lang=js"

import "./MusicPlayer.vue?vue&type=style&index=0&id=743da6ae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743da6ae"]])

export default __exports__